var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c, _d, _e, _f, _g, _h, _j;
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Curriculum as CurriculumModel } from '@/models/Curriculum';
import { UserSubject, UserSubjectStatusEnum } from '@/models/UserSubject';
import SelectFilter from '@/components/select-filter/SelectFilter';
import LoadFailed from '@/views/Errors/LoadFailed';
import { Student } from '@/models/Student';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { sortByKey } from '@/support/Object';
import { hex2rgba, formatDate } from '@/support/String';
import AlertCard from '@/components/alert-card/AlertCard';
import Chat from '@/components/chat/Chat';
import EnvironmentSelect from '@/components/environment-select/EnvironmentSelect';
import { whiteKidIcons, whiteAreaIcons } from '@/support/Icon';
import SubjectStatusSelect from '@/components/subject-status-select/SubjectStatusSelect';
import Storage from '@/support/Storage';
import { Template } from '@/models/Template';
import CreateIdpDialog from '@/components/curriculum/CreateIdpDialog';
import DownloadIdpDialog from '@/components/curriculum/DownloadIdpDialog/DownloadIdpDialog';
import ErrorHandler from '@/support/ErrorHandler';
import { Period } from '@/models/Period';
import EditSubjectDialog from '@/components/curriculum/EditSubjectDialog';
import { Year } from '@/models/Year';
import Rating from '@/components/rating/Rating';
import { excludeRoles } from '@/support/ExcludeRoles';
import { isEqual, cloneDeep } from 'lodash';
import { Group } from '@/models/Group';
import ProgressSelect from '@/components/progress-select/ProgressSelect';
import AbstractUrl from '@/support/AbstractUrl';
import TrafficLight from '@/components/TrafficLight/TrafficLight';
import { RolesEnum } from '@/items/Roles';
import { ADraggableItem } from '../Draggable/Draggable';
let CurriculumSelectDialog = class CurriculumSelectDialog extends AbstractUrl {
    constructor() {
        super(...arguments);
        this.hasMounted = false;
        this.currentPeriod = null;
        this.expanded = {};
        this.fileInput = null;
        this.filters = {};
        this.internalFilters = {};
        this.futurePeriod = null;
        this.isAchieved = false;
        this.isEditing = false;
        this.isLoading = true;
        this.isLoadingTopic = {};
        this.isTemplateFile = false;
        this.loadedTopics = {};
        this.periodFilter = { type: 'Period', value: '' };
        this.selectedFile = null;
        this.selectedLevel = { value: null };
        this.selectedPeriod = { value: null };
        this.selectedProject = null;
        this.selectedStatuses = {
            highlighted: true,
            busy: true,
            old: true,
        };
        this.selectedSubject = null;
        this.selectedTemplate = null;
        this.showAddSubjectDialog = false;
        this.showCreatingIdp = false;
        this.showDownloadIdp = false;
        this.showEditSubjectDialog = false;
        this.statuses = [];
        this.student_can_set_goal_to_yellow = true;
        this.subjects = [];
        this.subjectTarget = null;
        this.templates = [];
        this.totalCompleted = 0;
        this.totalCount = 0;
        this.totals = {};
        this.visible = {};
        this.isUpdatingStatus = false;
        this.selectedSubjects = [];
        this.initializationCount = {
            visible: {},
            expanded: {},
            totals: {},
            totalCount: 0,
            totalCompleted: 0,
        };
    }
    // Getters
    get userProjects() {
        return (this.student && this.student.projects) || [];
    }
    get icons() {
        const type = Storage.get('type');
        return type && type.toLowerCase() === 'po' ? whiteAreaIcons : whiteKidIcons;
    }
    get dialogOptions() {
        const subject = this.selectedSubject;
        return {
            title: subject.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 2, { item: this.$t('dialogOptions.item.subject') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!subject) {
                            return;
                        }
                        this.updateStatus(subject, 'dismissed');
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedSubject = null;
                    },
                },
            },
        };
    }
    get percentageColor() {
        if (this.percentComplete === 0) {
            return 'grey';
        }
        if (this.percentComplete < 33) {
            return 'orange';
        }
        if (this.percentComplete >= 33 && this.percentComplete <= 66) {
            return 'yellow';
        }
        return 'green';
    }
    get percentComplete() {
        if (this.totalCount === 0) {
            return 0;
        }
        const percentage = Math.round((this.totalCompleted / this.totalCount) * 100);
        return percentage;
    }
    get priorityLabel() {
        const setting = this.getSetting('priority_subjects_label');
        return (setting && setting.value) || 'MijnVoorrang';
    }
    get exclude() {
        return excludeRoles[this.$store.state.version].curriculum.subject.includes(this.$store.state.Auth.roles[0].id);
    }
    get isUserTeacher() {
        return !!this.$store.state.Auth.isTeacher;
    }
    get canSeeGreenTraficLight() {
        return !!this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.TEACHER, RolesEnum.ROOT, RolesEnum.RESELLER]);
    }
    get isTrafficLightDisabled() {
        return this.isUpdatingStatus;
    }
    mounted() {
        this.hasMounted = true;
        this.setSettings();
        this.setStatusFilters();
        if (this.student) {
            this.initialize();
        }
    }
    setSettings() {
        if (this.$store.state.Auth.isStudent) {
            const studentCanEditGoalToYellow = this.$store.state.settings.find((setting) => {
                return setting.key === 'student_can_set_goal_to_yellow';
            });
            if (studentCanEditGoalToYellow) {
                this.student_can_set_goal_to_yellow = studentCanEditGoalToYellow.value === '1' || studentCanEditGoalToYellow.value === true ? true : false;
            }
        }
    }
    async initialize() {
        this.isLoading = true;
        this.subjects = [];
        this.totals = {};
        this.totalCount = 0;
        this.totalCompleted = 0;
        if (this.$route.query.project && this.findProject()) {
            this.selectedProject = this.findProject();
        }
        if (this.type === 'student') {
            await this.fetchUserSubjects();
        }
        if (this.curriculumEditItem && this.curriculumEditItems) {
            this.$set(this, 'selectedSubjects', cloneDeep(this.curriculumEditItems));
        }
        const areas = this.curriculum.subjects || [];
        await this.formatCurriculum(areas);
        if (!this.$store.state.year) {
            this.fetchYear();
        }
        else {
            this.fetchPeriods();
        }
        this.isLoading = false;
    }
    async formatCurriculum(areas) {
        const promises = areas.map((area, index) => {
            return this.setupAreas(area, index);
        });
        await Promise.all(promises);
    }
    async setupAreas(area, index) {
        new Promise((resolve, reject) => {
            let count = 0;
            const topics = area.children || [];
            topics.forEach((topic) => {
                const subjects = this.subjectsForTopic(topic.id || '');
                count = count + subjects.length;
                this.initializationCount.visible[topic.id] = false;
                this.initializationCount.expanded[topic.id] = false;
                this.initializationCount.totals[topic.id] = subjects.length;
                this.initializationCount.visible[topic.id] = subjects.length > 0;
                subjects.forEach((subject, index) => {
                    if (subject.status === 'finished') {
                        this.initializationCount.totalCompleted++;
                    }
                });
            });
            this.initializationCount.visible[area.id] = count > 0;
            this.initializationCount.totals[area.id] = count;
            this.initializationCount.totalCount = this.initializationCount.totalCount + count;
            resolve();
        });
        this.visible = this.initializationCount.visible;
        this.expanded = { ...this.initializationCount.expanded, ...this.expanded };
        this.totals = this.initializationCount.totals;
        this.totalCount = this.initializationCount.totalCount;
        this.totalCompleted = this.initializationCount.totalCompleted;
    }
    onClickClose() {
        if (!this.curriculumEditItem || !this.curriculumEditItems) {
            this.$emit('close', this.selectedSubjects);
        }
        else {
            const emit = {
                item: this.curriculumEditItem,
                items: cloneDeep(this.selectedSubjects),
            };
            this.$emit('update', emit);
        }
        this.selectedSubjects = [];
    }
    onClickEdit() {
        this.$emit('edit');
    }
    onClickDelete() {
        this.$emit('delete');
    }
    async fetchUserSubjects() {
        await new UserSubject()
            .filter(this.filters)
            .include(['level', 'parent', 'period', 'projects'])
            .user(this.student)
            .limit(2000)
            .all()
            .then((subjects) => {
            subjects.sort(sortByKey('name')).forEach((subject, index) => {
                this.$set(subject, 'isVisible', true);
                if (!this.future && subject.status === 'future') {
                    subject.isVisible = false;
                }
                if (!this.dismissed && subject.status === 'dismissed') {
                    subject.isVisible = false;
                }
            });
            this.subjects = subjects;
            if (this.$route.query.subject) {
                new UserSubject()
                    .user(this.student.id || '')
                    .filter('id', this.$route.query.subject)
                    .first()
                    .then((userSubject) => {
                    this.showSubjectDialog(userSubject, true);
                })
                    .catch((error) => {
                    ErrorHandler.network(error);
                });
            }
        });
    }
    isEqual(object, other) {
        return isEqual(object, other);
    }
    async toggleAllSubjectStatus(topicId) {
        this.expanded[topicId] = true;
        if (this.loadedTopics[topicId]) {
            return;
        }
        this.$set(this.isLoadingTopic, topicId, true);
        const subjects = this.subjectsForTopic(topicId);
        for (const subject of subjects) {
            this.$refs[`statusCount-${subject.id}`][0].displaySummary();
        }
        for (let index = 0; index < subjects.length; index++) {
            const subject = subjects[index];
            await this.$refs[`statusCount-${subject.id}`][0].showSubjectSummary();
        }
        this.$set(this.isLoadingTopic, topicId, false);
        this.$set(this.loadedTopics, topicId, true);
    }
    setInvisible() {
        this.subjects.sort(sortByKey('name')).forEach((subject, index) => {
            this.$set(subject, 'isVisible', true);
            if (!this.future && subject.status === 'future') {
                subject.isVisible = false;
            }
            if (!this.dismissed && subject.status === 'dismissed') {
                subject.isVisible = false;
            }
        });
    }
    find(data, key, value, originArray = this.subjects) {
        const indexes = [];
        const index = -1;
        const subjects = [];
        data.forEach((item, index) => {
            if (item.parent[key] === value && item.status !== 'future') {
                indexes.push(index);
                subjects.push(originArray[index]);
            }
        });
        return subjects;
    }
    fetchYear() {
        new Year()
            .include('periods')
            .current()
            .then((year) => {
            this.$store.dispatch('loadedCurrentYear', year);
            this.fetchPeriods();
        })
            .catch(() => { });
    }
    fetchPeriods() {
        new Period()
            .filter('years', this.$store.state.year.id)
            .all()
            .then((periods) => {
            let futureIndex = -1;
            periods.forEach((period, index) => {
                if (period.is_current) {
                    this.currentPeriod = period;
                    futureIndex = index + 1;
                }
                if (futureIndex === index) {
                    this.futurePeriod = period;
                }
            });
        });
    }
    async updateStatus(subject, status, meta = {}, topicId = null) {
        this.isUpdatingStatus = true;
        const userSubjects = await new UserSubject().user(this.student).put([
            {
                ...meta,
                ...{
                    subject: subject.subject,
                    status,
                },
            },
        ]);
        if (userSubjects) {
            subject.status = status;
            this.parseSubjectDescription(subject.id || '', topicId, userSubjects);
            this.setInvisible();
        }
        if (this.selectedFile) {
            const collection = status === 'finished' ? status : 'default';
            const file = this.isTemplateFile ? this.selectedFile.links.download : this.selectedFile;
            subject.uploadFile([{ file, collection }]).then((response) => {
                this.$set(subject.files, collection, response.data);
            });
            this.selectedFile = null;
        }
        this.isUpdatingStatus = false;
    }
    subjectsForTopic(topicId) {
        return this.readOnly && this.readOnlySubjects ? this.find(this.readOnlySubjects, 'id', topicId, this.readOnlySubjects) : this.find(this.subjects, 'id', topicId);
    }
    totalTopicsForArea(areaId) {
        const areas = this.curriculum.subjects || [];
        const areaIndex = areas.findIndex((area) => area.id === areaId);
        const area = areas[areaIndex];
        const topics = area.children || [];
        return topics.filter((area) => this.visible[area.id]).length;
    }
    onClickFilterByPriority() {
        this.filters.has_priority = !this.filters.has_priority ? true : undefined;
        this.setQueryParams(this.filters);
        this.initialize();
    }
    totalSubjectsForArea(area) {
        if (!area.id) {
            return;
        }
        let count = 0;
        const topics = area.children || [];
        topics.forEach((topic) => {
            if (!topic.id) {
                return;
            }
            const subjects = this.subjectsForTopic(topic.id);
            subjects.forEach((subject) => {
                if (subject.isVisible) {
                    count += 1;
                }
            });
        });
        return count;
    }
    onFileChange(event) {
        if (!event.target.files.length || this.subjectTarget === null) {
            return;
        }
        this.fileInput = event.target;
        this.selectedFile = event.target.files[0];
        if (!this.selectedFile) {
            return;
        }
    }
    removeSelectedFile() {
        this.selectedFile = null;
        if (this.fileInput) {
            this.fileInput.removeAttribute('value');
            this.fileInput.setAttribute('value', '');
        }
    }
    deleteFile() {
        if (this.subjectTarget && this.subjectTarget.files) {
            this.subjectTarget.files = [];
        }
    }
    subjectStatusClasses(subject) {
        return {
            highlighted: subject.status === 'highlighted',
            busy: subject.status === 'busy',
            old: subject.status === 'old',
            closed: subject.status === 'closed',
            finished: subject.status === 'finished',
        };
    }
    areaBlockStyles(area) {
        const color = area.color || '#000';
        return {
            backgroundColor: color,
        };
    }
    topicRowStyles(area) {
        const color = area.color || '#000';
        const lightColor = hex2rgba(color, 0.3);
        return {
            backgroundColor: `${lightColor}`,
        };
    }
    toggleStatus(status) {
        this.selectedStatuses[status] = !this.selectedStatuses[status];
        if (this.type === 'student') {
            this.setStatusFilters();
        }
        this.initialize();
    }
    handleSubjectsAdded(future = false) {
        this.initialize();
    }
    showSubjectDialog(subject, ignoreStatusCheck = false) {
        if (['dismissed', 'future'].includes(subject.status || '') && !ignoreStatusCheck) {
            return;
        }
        this.subjectTarget = subject;
        this.showEditSubjectDialog = true;
        const subjectId = this.subjectTarget.subject || '';
        if (!this.$store.state.Auth.hasRole([RolesEnum.GUARDIAN, RolesEnum.STUDENT])) {
            this.getTemplates(subjectId);
        }
    }
    showSubject(subject, topic) {
        this.$router.push(`/subjects/${topic.id}?group=${this.group.id}&level=${subject.level.id || ''}&project=${this.group && this.group.projects ? this.group.projects.length > 0 : ''}`).catch(() => { });
    }
    getTemplates(subjectId) {
        new Template()
            .subject(subjectId)
            .include('file')
            .all()
            .then((templates) => {
            this.templates = templates;
        });
    }
    updateSubject(subject) {
        this.selectedSubject = subject;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    handleNewSubject(subjects) {
        this.initialize();
    }
    levelClassesForSubject(subject) {
        if (this.type === 'group') {
            return {
                ahead: false,
                behind: false,
            };
        }
        if (subject.level === undefined) {
            return {};
        }
        const subjectLevel = subject.level;
        if (this.student.level === undefined) {
            return {};
        }
        const studentLevel = this.student.level;
        return {
            ahead: subjectLevel.sequence > studentLevel.sequence,
            behind: subjectLevel.sequence < studentLevel.sequence,
        };
    }
    formatDate(date) {
        return formatDate(date);
    }
    redirect(area, topic, subject) {
        this.$router.push(`/students/${this.student.id}/portfolio?area=${area.id}&topic=${topic.id}&subject=${subject.subject}`).catch(() => { });
    }
    findProject(id) {
        const projectId = id || this.$route.query.project;
        return this.userProjects.find((project) => project.id === projectId) || null;
    }
    parseSubjectDescription(subjectId, topicId, userSubjects) {
        if (!topicId) {
            return;
        }
        const userSubject = userSubjects.find((currentUserSubject) => currentUserSubject.id === subjectId);
        if (!userSubject) {
            return;
        }
        const subjects = this.subjectsForTopic(topicId);
        const subject = subjects.find((subject) => subject.id === subjectId);
        if (!subject) {
            return;
        }
        subject.description = userSubject.description || '';
    }
    subjectStatusLabel(status) {
        if (!status) {
            return this.$tc(`idp.status.inactive`, 2);
        }
        const label = this.$store.state.labels.find((label) => {
            return label.key === status;
        });
        if (!label || label.value === label.key) {
            return this.$tc(`idp.status.${status}`, 2);
        }
        else {
            return label.value;
        }
    }
    setStatusFilters() {
        if (this.future) {
            this.filters.statuses = ['future'];
            return;
        }
        if (this.dismissed) {
            this.filters.statuses = ['dismissed'];
            return;
        }
        const statusFilters = [];
        Object.keys(this.selectedStatuses).forEach((key) => {
            if (this.selectedStatuses[key]) {
                statusFilters.push(key);
            }
        });
        this.filters.statuses = statusFilters;
        this.setQueryParams(this.filters);
    }
    isVersion(version) {
        return version == this.$store.state.version;
    }
    navigateToSubject(subject) {
        if (!subject.id || !this.group.id) {
            return;
        }
        this.$router.push({ name: 'subject.lvs', params: { subjectid: subject.id } }).catch(() => { });
    }
    isYellowTrafficLightVisible(subject) {
        return !!(this.type !== 'group' && ((this.$store.state.Auth.hasRole([RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.STUDENT, RolesEnum.RESELLER, RolesEnum.ROOT]) && subject.status === 'busy') || subject.status === 'old') && this.student_can_set_goal_to_yellow);
    }
    isGreenTrafficLightVisible(subject) {
        return !!(this.canSeeGreenTraficLight && subject.status !== UserSubjectStatusEnum.FINISHED && subject.status !== UserSubjectStatusEnum.OLD);
    }
    getSetting(key) {
        return this.$store.getters.getSetting(key);
    }
    async handleTrafficLightChange(subject, status, topicId, event) {
        event.setLoadingStateOn();
        await this.updateStatus(subject, status, {}, topicId).catch(() => {
            event.setLoadingStateOff();
        });
        event.setLoadingStateOff();
    }
    tabChange(changed) {
        if (changed) {
            this.setInvisible();
        }
    }
    onreadOnlySubjectsChange(newValue, oldValue) {
        if (!this.readOnly || isEqual(newValue, oldValue) || !this.hasMounted) {
            return;
        }
        this.initialize();
    }
    studentChange(newValue, oldValue) {
        if (isEqual(newValue, oldValue) || !this.hasMounted) {
            return;
        }
        this.initialize();
    }
    onSelectedProjectChanged(selectedProject) {
        if (this.filters.project === (selectedProject && selectedProject.id)) {
            return;
        }
        if (!selectedProject) {
            delete this.filters.project;
        }
        else {
            this.filters = {
                ...this.filters,
                project: selectedProject && selectedProject.id,
            };
        }
        if (!this.isLoading) {
            this.setQueryParams(this.filters);
            this.initialize();
        }
    }
    selectedLevelChanged(selectedLevel) {
        // No change don't call API and update query
        if (this.filters.levels === selectedLevel.value) {
            return;
        }
        this.filters = {
            ...this.filters,
            levels: selectedLevel.value,
        };
        if (!this.isLoading) {
            this.setQueryParams(this.filters);
            this.initialize();
        }
    }
    selectedPeriodChanged(selectedPeriod) {
        // No change don't call API and update query
        if (this.filters.periods === selectedPeriod.value) {
            return;
        }
        this.filters = {
            ...this.filters,
            periods: selectedPeriod.value,
        };
        if (!this.isLoading) {
            this.setQueryParams(this.filters);
            this.initialize();
        }
    }
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof CurriculumModel !== "undefined" && CurriculumModel) === "function" ? _a : Object)
], CurriculumSelectDialog.prototype, "curriculum", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], CurriculumSelectDialog.prototype, "dismissed", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], CurriculumSelectDialog.prototype, "future", void 0);
__decorate([
    Prop(),
    __metadata("design:type", typeof (_b = typeof Group !== "undefined" && Group) === "function" ? _b : Object)
], CurriculumSelectDialog.prototype, "group", void 0);
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_c = typeof Student !== "undefined" && Student) === "function" ? _c : Object)
], CurriculumSelectDialog.prototype, "student", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], CurriculumSelectDialog.prototype, "tabChanged", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], CurriculumSelectDialog.prototype, "infoVisible", void 0);
__decorate([
    Prop({ default: 'student' }),
    __metadata("design:type", String)
], CurriculumSelectDialog.prototype, "type", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], CurriculumSelectDialog.prototype, "readOnly", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", Array)
], CurriculumSelectDialog.prototype, "readOnlySubjects", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_d = typeof ADraggableItem !== "undefined" && ADraggableItem) === "function" ? _d : Object)
], CurriculumSelectDialog.prototype, "curriculumEditItem", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", Array)
], CurriculumSelectDialog.prototype, "curriculumEditItems", void 0);
__decorate([
    Watch('tabChanged'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], CurriculumSelectDialog.prototype, "tabChange", null);
__decorate([
    Watch('curriculumEditItems', { immediate: true, deep: true }),
    Watch('readOnlySubjects', { immediate: true, deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array, Array]),
    __metadata("design:returntype", void 0)
], CurriculumSelectDialog.prototype, "onreadOnlySubjectsChange", null);
__decorate([
    Watch('student', { immediate: true, deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_e = typeof Student !== "undefined" && Student) === "function" ? _e : Object, typeof (_f = typeof Student !== "undefined" && Student) === "function" ? _f : Object]),
    __metadata("design:returntype", void 0)
], CurriculumSelectDialog.prototype, "studentChange", null);
__decorate([
    Watch('selectedProject'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_g = typeof Record !== "undefined" && Record) === "function" ? _g : Object]),
    __metadata("design:returntype", void 0)
], CurriculumSelectDialog.prototype, "onSelectedProjectChanged", null);
__decorate([
    Watch('selectedLevel'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_h = typeof Record !== "undefined" && Record) === "function" ? _h : Object]),
    __metadata("design:returntype", void 0)
], CurriculumSelectDialog.prototype, "selectedLevelChanged", null);
__decorate([
    Watch('selectedPeriod'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_j = typeof Record !== "undefined" && Record) === "function" ? _j : Object]),
    __metadata("design:returntype", void 0)
], CurriculumSelectDialog.prototype, "selectedPeriodChanged", null);
CurriculumSelectDialog = __decorate([
    Component({
        components: {
            AlertCard,
            Chat,
            EnvironmentSelect,
            LoaderCard,
            LoadFailed,
            SelectFilter,
            SubjectStatusSelect,
            CreateIdpDialog,
            EditSubjectDialog,
            Rating,
            DownloadIdpDialog,
            ProgressSelect,
            TrafficLight,
        },
    })
], CurriculumSelectDialog);
export default CurriculumSelectDialog;
